export const ERROR_MESSAGES = {
    Default: { code: 0, message: "Ocurrió un error inesperado. Vuelva a intentar en unos minutos" },
    DefaultInvalidOTPCode: { code: 0, message: "Código OTP incorrecto. Intente nuevamente" }
};

export const DIMENSION_COLORS = ['rgb(45,84,118)', 'rgba(155, 86, 255, 0.8)', 'rgba(224, 54, 146, 0.8)', 'rgba(255, 119, 50, 0.8)', 'rgba(61, 213, 255, 0.8)', 'rgba(0, 157, 67, 0.8)', 'rgba(0, 209, 90, 0.8)', 'rgba(16, 181, 171, 0.8)'];

export const TEST_TYPES = {
    Profile: { id: 1, name: 'Profile' },
    Hoy: { id: 2, name: 'Hoy' },
    Futuro: { id: 3, name: 'Futuro' },
    Autoconocimiento: { id: 4, name: 'Autoconocimiento' }
}

export const QUESTION_STATUS = {
    Pendiente: { id: 1, name: 'Penndiente' },
    Contestado: { id: 2, name: 'Contestado' }
}

export const SALARY_RANGES = [
    { id: 1, name: '0 - 10 000' },
    { id: 2, name: '10 001 - 20 000' },
    { id: 3, name: 'Más de 20 001' }
]

export const STATES_OBJECTIVES = {
    Terminado: { id: 1, name: 'Terminado', color: '#4CAF50' }, // Verde
    PorVencer: { id: 2, name: 'Por Vencer', color: '#FF9800' }, // Naranja
    Atrasado: { id: 3, name: 'Atrasado', color: '#F44336' }, // Rojo
    Eliminado: { id: 4, name: 'Eliminado', color: '#9E9E9E' }, // Gris
    EnProgreso: { id: 5, name: 'En progreso', color: '#2196F3' }, // Azul
};

export const USER_TYPES = {
    Customer: { id: 1, name: 'Cliente' },
    Coach: { id: 2, name: 'Coach' },
    Administrator: { id: 3, name: 'Administrativo' },
    Expert: { id: 4, name: 'Experto' }
};

export const COACH_TYPES = {
    Professional: { id: 1, name: 'Professional' },
    Executive: { id: 2, name: 'Executive' }
};

export const SUBSCRIPTION_TYPES = {
    Freemium: { id: 1, name: 'Freemium' },
    Professional: { id: 2, name: 'Professional' },
    Executive: { id: 3, name: 'Executive' }
};